/**
 * Der Ausgang einer Sektion als Textlink — kein Knopf.
 *
 * Hintergrund (Jan, 3.8.2026): Auf der Startseite trugen die Sektions-Ausgaenge
 * drei verschiedene Gestalten — Knopf (`primary`), Knopf (`secondary`) und
 * unterstrichener Fettext. Sie fuehren aber alle dasselbe aus: weiterlesen.
 *
 * Die Regel seither: **«Termin vereinbaren» ist der einzige primaere Knopf.**
 * Was in eine andere Sektion oder auf eine Unterseite fuehrt, ist ein Textlink;
 * Knoepfe bleiben den Karten-Ausgaengen und dem Abschluss-Block.
 *
 * Diese Komponente haelt die Gestalt an einer Stelle fest. Vorher stand sie
 * dreimal kopiert im Code, und zwei Kopien waren bereits auseinandergelaufen.
 *
 * Der Pfeil ist Dekoration (`aria-hidden`) — der Linkname bleibt der Text
 * allein, sonst liest ein Screenreader «Unsere Angebote ansehen Pfeil nach
 * rechts».
 */

import React from "react";
import { Link } from "react-router-dom";

export type SectionTextLinkProps = {
    /** Bereits lokalisiertes Ziel — die aufrufende Sektion loest `useLocalizedUrl` auf. */
    to: string;
    children: React.ReactNode;
    className?: string;
};

export const SectionTextLink: React.FC<SectionTextLinkProps> = ({ to, children, className = "" }) => (
    <Link
        to={to}
        className={`inline-flex items-center gap-1 text-lg font-semibold text-primary underline-offset-4
            hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ${className}`}
    >
        {children}
        <span aria-hidden="true">→</span>
    </Link>
);

export default SectionTextLink;
